import { Bar } from 'vue-chartjs'
import { isEmpty } from 'lodash'
import { commaFormatString } from '@/helpers'

// if we need a line on the graph we can use this example - http://jsfiddle.net/zk9oc4c9/
// or we can use this plugin - https://github.com/chartjs/chartjs-plugin-annotation

const graphId = 'universe-graph'

export default Bar.extend({
  props: {
    data: {
      type: Object,
      required: true
    },
    chartId: {
      type: String,
      default: graphId
    }
  },
  data () {
    return {
      backgroundColor: null,
      hoverBackgroundColor: null
    }
  },
  computed: {
    chartData () {
      // TODO: must clean out gradient code
      // if (this.backgroundColor !== null && this.data.datasets.length > 0) {
      //   this.data.datasets[0].backgroundColor = this.backgroundColor
      //   this.data.datasets[0].hoverBackgroundColor = this.hoverBackgroundColor
      // }
      return this.data
    },
    options () {
      let ticks = {
        padding: 4,
        fontSize: 13,
        callback: function (value) {
          return commaFormatString(String(value))
        }
      }
      if (!this.data || isEmpty(this.data) || this.data.datasets.length === 0) {
        ticks.min = 0
        ticks.max = 500000
      }
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 0
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            barPercentage: 1,
            maxBarThickness: 80,
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7'
            },
            ticks: {
              fontSize: 13
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              zeroLineColor: '#0052E7'
            },
            ticks
          }]
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function (tooltip, data) {
              return `${data.datasets[tooltip.datasetIndex].label}: ${commaFormatString(String(tooltip.yLabel))}`
            }
          }
        }
      }
    }
  },
  mounted () {
    // the gradient Background forces us to add this extra bloat
    const chart = document.getElementById(this.chartId)
    const ctx = document.getElementById(this.chartId).getContext('2d')
    const gradient = ctx.createLinearGradient(0, 0, 0, chart.height)
    gradient.addColorStop(0, 'rgba(117, 227, 255, 0.7)')
    gradient.addColorStop(0.1, 'rgba(117, 227, 255, 0.7)')
    gradient.addColorStop(1, 'rgba(0, 82, 255, 0.9)')
    this.backgroundColor = gradient
    const hoverGradient = ctx.createLinearGradient(0, 0, 0, chart.height)
    hoverGradient.addColorStop(0, 'rgba(117, 227, 255, 1)')
    hoverGradient.addColorStop(0.1, 'rgba(117, 227, 255, 1)')
    hoverGradient.addColorStop(1, 'rgba(0, 82, 255, 1)')
    this.hoverBackgroundColor = hoverGradient
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    'chartData': {
      handler (newData, oldData) {
        if (oldData) {
          let chart = this._chart

          // Get new and old DataSet Labels
          let newDatasetLabels = newData.datasets.map((dataset) => {
            return dataset.label
          })

          let oldDatasetLabels = oldData.datasets.map((dataset) => {
            return dataset.label
          })

          // Stringify 'em for easier compare
          const oldLabels = JSON.stringify(oldDatasetLabels)
          const newLabels = JSON.stringify(newDatasetLabels)

          // Check if Labels are equal and if dataset length is equal
          if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
            newData.datasets.forEach((dataset, i) => {
              // Get new and old dataset keys
              const oldDatasetKeys = Object.keys(oldData.datasets[i])
              const newDatasetKeys = Object.keys(dataset)

              // Get keys that aren't present in the new data
              const deletionKeys = oldDatasetKeys.filter((key) => {
                return key !== '_meta' && newDatasetKeys.indexOf(key) === -1
              })

              // Remove outdated key-value pairs
              deletionKeys.forEach((deletionKey) => {
                delete chart.data.datasets[i][deletionKey]
              })

              // Update attributes individually to avoid re-rendering the entire chart
              for (const attribute in dataset) {
                if (dataset.hasOwnProperty(attribute)) {
                  chart.data.datasets[i][attribute] = dataset[attribute]
                }
              }
            })

            chart.data.labels = newData.labels
            chart.update()
          } else {
            chart.destroy()
            this.renderChart(this.chartData, this.options)
          }
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/app/appComponents/graphs/UniverseStabilityGraph.js